import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { AuthShell, Field } from "@/components/AuthShell";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

const cls = "w-full h-12 px-4 bg-zinc-900 border border-zinc-700 text-white font-mono focus:outline-none focus:border-white transition-colors duration-150";

export default function AdminLogin() {
  const { user, login, logout } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("sadm@studio");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user?.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") {
        logout();
        toast.error("Questo account non ha privilegi di Super Admin");
        return;
      }
      nav("/admin");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell dark eyebrow="Accesso riservato" title={<>Console<br />Super Admin.</>}>
      <form onSubmit={submit} className="space-y-6 [&_span.block]:!text-zinc-400" data-testid="admin-login-form">
        <Field label="Email amministratore">
          <input data-testid="admin-login-email-input" className={cls} value={email} onChange={(e) => setEmail(e.target.value)} required />
        </Field>
        <Field label="Password">
          <input data-testid="admin-login-password-input" type="password" className={cls} value={password} onChange={(e) => setPassword(e.target.value)} required />
        </Field>
        <button data-testid="admin-login-submit-btn" disabled={loading} className="inline-flex items-center gap-2 h-12 px-6 bg-[#2DD4BF] text-zinc-950 font-semibold hover:bg-[#4ADE80] hover:text-zinc-950 transition-colors duration-150 disabled:opacity-50">
          <ShieldCheck className="w-4 h-4" /> {loading ? "Verifica…" : "Entra nella console"}
        </button>
      </form>
    </AuthShell>
  );
}
